import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from '../../axios/axios'; // make sure this path is correct
import { toast } from "react-toastify";

const TokenHandler = ({ setCompLoad, setAuthData }) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');

    if (token) {
      setCompLoad?.(true);

      axios
        .get(`auto-login?token=${token}`)
        .then((res) => {
          const data = res.data?.data;
          if (data?.token) {
            localStorage.setItem('dealerModuleToken', data.token);
            setAuthData?.(data);
            navigate('/', { replace: true }); // Redirect to home
          }
        })
        .catch((err) => {
          console.error('Auto-login failed:', err);
          toast.error("Invalid Credentials");
        })
        .finally(() => {
          setCompLoad?.(false);
        });
    }
  }, [location.search]);

  return null;
};

export default TokenHandler;
